import { DefaultSections, startPresentation } from "@presentation/Types";

import Introduction from "./Slides/IntroAndOutro/Introduction.vue";
import ThankYou from "./Slides/IntroAndOutro/ThankYou.vue";
import Challenge from "./Slides/Challenge/Challenge.vue";
import Solution from "./Slides/Challenge/Solution.vue";
import EligibilityCriteria from "./Slides/WorkOrders/EligibilityCriteria.vue";
import RegulatoryCompliance from "./Slides/WorkOrders/RegulatoryCompliance.vue";
import ContractCreation from "./Slides/WorkOrders/ContractCreation.vue";
import WorkOrderParameters from "./Slides/WorkOrders/WorkOrderParameters.vue";
import WorkOrderProcedure from "./Slides/WorkOrders/WorkOrderProcedure.vue";
import NextSteps from "./Slides/NextSteps/NextSteps.vue";
import BusinessManager from "./Slides/NextSteps/BusinessManager.vue";
import Salesperson from "./Slides/NextSteps/Salesperson.vue";
import ServiceAdvisor from "./Slides/NextSteps/ServiceAdvisor.vue";
import Partnership from "./Slides/Partnership/Partnership.vue";

export const useOnboardingPresentation = () => startPresentation(
{

    key: 'onboarding',
    title: 'Onboarding Presentation',
    password: 'littledave',
    enableNextSlideIndicator: true,

    sections: [

        // Introduction
        { 
            name: DefaultSections.Start, 
            title: 'Introduction',
            displayPageTitle: false,
            isAppendix: false,
            hasTitlePage: false,
            pages: [
                { component: Introduction }
            ],
            images: [
                '/carbucks-driven-by-presidian.png',
                '/carbucks-logo.png',
                '/background-overlay.jpg',
                '/pending.jpg'
            ]
        },

        // Challenge
        { 
            name: 'challenge', 
            title: 'Challenge',
            displayPageTitle: false,
            isAppendix: false,
            hasTitlePage: true,
            pages: [
                { component: Challenge, title: 'Challenges' },
                { component: Solution, title: 'Solution' },
            ],
            images: [
                '/Challenge/solution.png',
            ]
        },
        
        // What is Carbucks
        { 
            name: 'what-is-carbucks'
        },

        // Marketplace
        { 
            name: 'marketplace'
        },

        // Consumer Proposition
        { 
            name: 'consumer-proposition'
        },

        // Demo
        { 
            name: 'demo'
        },

        // Next Steps
        { 
            name: 'next-steps', 
            title: 'Next Steps',
            displayPageTitle: true,
            isAppendix: false,
            hasTitlePage: true,
            pages: [
                { component: Salesperson, title: 'What it means for Sales' },
                { component: BusinessManager, title: 'What it means for Finance' },
                { component: ServiceAdvisor, title: 'What it means for Service' },
                { component: NextSteps, title: 'Next Steps' },
            ],
            images: [

            ]   
        },

        // Thank You
        { 
            name: DefaultSections.End, 
            title: 'Questions',
            displayPageTitle: false,
            isAppendix: false,
            hasTitlePage: false,
            pages: [
                { component: ThankYou }
            ],
            images: [ 
                '/background-overlay-3.jpg',
            ]   
        },
        
        // Terms and Conditions
        { 
            name: 'terms-and-conditions'   
        },

        // Work Orders
        { 
            name: 'work-orders', 
            title: 'Work Orders',
            displayPageTitle: true,
            isAppendix: true,
            hasTitlePage: true,
            pages: [
                { component: EligibilityCriteria, title: 'Eligibility Criteria' },
                { component: RegulatoryCompliance, title: 'Regulatory Compliance' },
                { component: WorkOrderParameters, title: 'Work Order Parameters' },
                { component: ContractCreation, title: 'Contract Creation' },
                { component: WorkOrderProcedure, title: 'Work Order Procedure' }
            ],
            images: [
                '/WorkOrders/eligibility.jpg',
                '/WorkOrders/parameters.jpg',
                '/WorkOrders/contract-creation.png',
                '/WorkOrders/procedure.jpg'
            ]   
        },

        // Point of Sale
        { 
            name: 'point-of-sale'
        },

        // Partnership
        { 
            name: 'partnership', 
            title: 'Presidian / CV Partnership',
            displayPageTitle: true,
            isAppendix: true,
            hasTitlePage: false,
            pages: [
                { component: Partnership }
            ],
            images: [
                '/connected-vehicles-logo.png',
                '/presidian-group-logo.png',
            ]   
        }

    ]

})
